import React, { useEffect } from 'react';

const HetznerInstallationCTA = ({openModal}) => {
  useEffect(() => {
    const animateElements = () => {
      const elements = document.querySelectorAll('.fade-in-up');
      elements.forEach(element => {
        const rect = element.getBoundingClientRect();
        const isVisible = rect.top < window.innerHeight - 100;
        if (isVisible) {
          element.classList.add('animated');
        }
      });
    };

    animateElements();
    window.addEventListener('scroll', animateElements);
    
    return () => {
      window.removeEventListener('scroll', animateElements);
    };
  }, []);

  const handleConsultationClick = () => {
    // Add your consultation scheduling logic here
    console.log('Schedule consultation clicked');
    // Example: open modal, navigate to booking page, etc.
  };

  const handleDeploymentClick = (e) => {
    e.preventDefault();
    const element = document.getElementById('installation');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const features = [
    {
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-6 h-6 text-white">
          <path strokeLinecap="round" strokeLinejoin="round" d="M11.42 15.17 17.25 21A2.652 2.652 0 0 0 21 17.25l-5.877-5.877M11.42 15.17l2.496-3.03c.317-.384.74-.626 1.208-.766M11.42 15.17l-4.655 5.653a2.548 2.548 0 1 1-3.586-3.586l6.837-5.63m5.108-.233c.55-.164 1.163-.188 1.743-.14a4.5 4.5 0 0 0 4.486-6.336l-3.276 3.277a3.004 3.004 0 0 1-2.25-2.25l3.276-3.276a4.5 4.5 0 0 0-6.336 4.486c.091 1.076-.071 2.264-.904 2.95l-.102.085m-1.745 1.437L5.909 7.5H4.5L2.25 3.75l1.5-1.5L7.5 4.5v1.409l4.26 4.26m-1.745 1.437 1.745-1.437m6.615 8.206L15.75 15.75M4.867 19.125h.008v.008h-.008v-.008Z" />
        </svg>
      ),
      text: "Expert cloud migration and infrastructure deployment tailored to your business needs"
    },
    {
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-6 h-6 text-white">
          <path strokeLinecap="round" strokeLinejoin="round" d="M9 12.75 11.25 15 15 9.75m-3-7.036A11.959 11.959 0 0 1 3.598 6 11.99 11.99 0 0 0 3 9.749c0 5.592 3.824 10.29 9 11.623 5.176-1.332 9-6.03 9-11.622 0-1.31-.21-2.571-.598-3.751h-.152c-3.196 0-6.1-1.248-8.25-3.285Z" />
        </svg>
      ),
      text: "Secure, scalable, and performance-optimized configurations following industry best practices"
    },
    {
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-6 h-6 text-white">
          <path strokeLinecap="round" strokeLinejoin="round" d="M18 18.72a9.094 9.094 0 0 0 3.741-.479 3 3 0 0 0-4.682-2.72m.94 3.198.001.031c0 .225-.012.447-.037.666A11.944 11.944 0 0 1 12 21c-2.17 0-4.207-.576-5.963-1.584A6.062 6.062 0 0 1 6 18.719m12 0a5.971 5.971 0 0 0-.941-3.197m0 0A5.995 5.995 0 0 0 12 12.75a5.995 5.995 0 0 0-5.058 2.772m0 0a3 3 0 0 0-4.681 2.72 8.986 8.986 0 0 0 3.74.477m.94-3.197a5.971 5.971 0 0 0-.94 3.197M15 6.75a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm6 3a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Zm-13.5 0a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Z" />
        </svg>
      ),
      text: "Dedicated technical support, monitoring, and ongoing infrastructure management"
    }
  ];

  return (
    <section className="py-10 ">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        
        {/* Header Section */}
        <div className="text-center mb-12 fade-in-up transition-all duration-700">
          <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4">
            Cloud Infrastructure Services with AyanshTech Solutions
          </h2>
          <div className="accent-line h-1 bg-green-500 mx-auto mb-6 transition-all duration-700 ease-out w-16"></div>
        </div>

        {/* Main CTA Card */}
        <div className="relative fade-in-up transition-all duration-700 delay-100">
          {/* Gradient Background */}
          <div className="absolute inset-0 bg-gradient-to-br from-green-500 to-green-600 rounded-3xl"></div>
          <div className="absolute inset-0 bg-gradient-to-br from-black/10 to-black/30 rounded-3xl"></div>
          
          {/* Content */}
          <div className="relative p-8 md:p-12 text-white">
            <h3 className="text-xl md:text-2xl font-bold mb-8 text-center">
             Professional Hetzner Deployment & Management
            </h3>
            
            {/* Features Grid */}
            <div className="grid md:grid-cols-3 gap-6 text-center mb-8">
              {features.map((feature, index) => (
                <div key={index} className="space-y-4">
                  <div className="w-12 h-12 bg-white/20 rounded-xl mx-auto flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                    {feature.icon}
                  </div>
                  <p className="text-sm md:text-base leading-relaxed">{feature.text}</p>
                </div>
              ))}
            </div>
            
            {/* Buttons */}
            <div className="text-center space-y-4">
              <div>
                <a 
                  href="/hetzner/#installation" 
                  onClick={handleDeploymentClick}
                  className="bg-white text-blue-600 font-bold py-4 px-8 rounded-xl hover:bg-gray-100 transition-all duration-300 inline-block shadow-lg hover:shadow-xl transform hover:-translate-y-0.5"
                >
                  Deployment Services & Infrastructure Details
                </a>
              </div>
              <div>
                <button 
                  onClick={openModal}
                  className="bg-transparent border-2 border-white text-white font-bold py-3 px-8 rounded-xl hover:bg-white/10 transition-all duration-300 inline-block transform hover:-translate-y-0.5"
                >
                  Schedule a Free Consultation
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HetznerInstallationCTA;